<template>
    <section class="container-fluid content-type-37 graph" v-if="hasStats && stats.label && Object.keys(stats.label).length > 1">
        <div class="container">
            <div class="row">
                <div class="col-12 hidden-sm-up">
                    <div class="h5 title">{{$t('views.audience.sections.labels.title')}}</div>
                </div>
                <div class="col-6 col-sm-5 col-sm-offset-1 col-xl-4 col-xl-offset-2">
                    <GraphPie :chartData="pieChartData" />
                </div>

                <div class="col-12 col-sm-6 col-xl-5">
                    <div class="content">
                        <div class="hidden-up visible-sm-up h5 title">{{$t('views.audience.sections.labels.title')}}</div>
                        <ul class="stats clickable">
                            <li class="stat" v-if="stats.label['1']" @click="openProspects('1')">
                                <div class="name">{{$t('fields.prospects_filter_label_alt.option_1')}}</div>
                                <div class="value">{{formatNumber(stats.label['1'])}}</div>
                            </li>
                            <li class="stat" v-if="stats.label['0']" @click="openProspects('0')">
                                <div class="name">{{$t('fields.prospects_filter_label_alt.option_0')}}</div>
                                <div class="value">{{formatNumber(stats.label['0'])}}</div>
                            </li>
                            <li class="stat" v-if="stats.label['-1']" @click="openProspects('-1')">
                                <div class="name">{{$t('fields.prospects_filter_label_alt.option_seen')}}</div>
                                <div class="value">{{formatNumber(stats.label['-1'])}}</div>
                            </li>
                            <li class="stat" v-if="othersValue" @click="openProspects('-1')">
                                <div class="name">{{$t('fields.prospects_filter_label_alt.option_unseen')}}</div>
                                <div class="value">{{formatNumber(othersValue)}}</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import GraphPie from '@/components/misc/GraphPie.vue';
    import { mapState } from 'pinia';
    import { formatNumber } from '@/utils/formatting';
    import { useAccountStore } from '@/stores/account';

    export default {
        name: "DashboardLabels",
        components: { GraphPie },
        computed: {
            ...mapState(useAccountStore, ['hasStats', 'stats']),
            othersValue() {
                return (this.stats.prospects || this.stats.total) - (this.stats.label['1'] || 0) - (this.stats.label['0'] || 0) - (this.stats.label['-1'] || 0);
            },
            pieChartData() {
                return {
                    labels: [
                        this.$t('fields.prospects_filter_label_alt.option_1'),
                        this.$t('fields.prospects_filter_label_alt.option_0'),
                        this.$t('fields.prospects_filter_label_alt.option_seen'),
                        this.$t('fields.prospects_filter_label_alt.option_unseen'),
                    ],
                    datasets: [{
                        data: [
                            this.stats.label['1'] || 0,
                            this.stats.label['0'] || 0,
                            this.stats.label['-1'] || 0,
                            this.othersValue
                        ],
                        backgroundColor: ['#4AAD52', '#CA2E55', '#0075F2', '#F7B538']
                    }]
                }
            }
        },
        methods: {
            formatNumber,
            openProspects(label) {
                this.$router.push({
                    name: 'prospects',
                    query: { 
                        prospectOptions: JSON.stringify({
                            reset: true,
                            options: {
                                label: label
                            }
                        })
                    }
                });
            }
        }
    }
</script>